import { put } from 'redux-saga/effects';
import { v4 as uuid } from 'uuid';
import { __t } from '../../utils/t';

import { appActions } from '../slices/appSlice';

export function* baseErrorHandler(error: unknown) {
    yield put(
        appActions.enqueueSnackbar({
            id: uuid(),
            title: __t('Что-то пошло не так!'),
            message: __t('Попробуйте перезагрузить страницу или связаться с нашей поддержкой.'),
            icon: 'triangle-exclamation-duonote-red',
            iconColor: 'danger',
        }),
    );
    console.error(error);
}
